import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import AdminLayout from '../Componets/AdminLayout';
import { ToastContainer, toast } from 'react-toastify';

export default function AddSection() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [loaded, setLoaded] = useState(false);
  const location = useLocation();
  const { id, subjectId } = location.state || {};
  const currentPath = location?.pathname || '';
  const navigate = useNavigate();
  const [selectionType, setSelectionType] = useState('one');
  const [isOtherSection, setIsOtherSection] = useState(false);
  const [examName, setExamName] = useState('');
  const focusInputRef = useRef(null);
  const [isAnyQus, setIsAnyQus] = useState(false);
  const [noOfAnyQus, setNoOfAnyQus] = useState(1);
  const [isAnyQusMarks, setIsAnyQusMarks] = useState(null);
  const [marksData, setMarksData] = useState(0);
  const [totalquestions, setTotalquestions] = useState(0);
  const [orqsn, setOrqsn] = useState(false);
  const [objectives, setObjectives] = useState([]);

  const [rows, setRows] = useState([
    {
      no: '',
      question: '',
      orQuestion: '',
      marks: '',
      subjectObjectiveId: '',
      isOtherQuestions: false,
    },
  ]);
  const [otherRows, setOtherRows] = useState([
    {
      no: '',
      question: '',
      orQuestion: '',
      marks: '',
      subjectObjectiveId: '',
      isOtherQuestions: false,
    },
  ]);

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
    focus();
    fetchObjectives();
  }, [navigate]);

  const fetchObjectives = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(
        `${apiUrl}/api/subject-objective/subject/${subjectId}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      setObjectives(response.data.subject.subjectObjectives);
    } catch (error) {
      console.error('Error fetching objectives:', error);
      toast.error('Failed to load objectives');
    }
  };

  const focus = () => {
    if (focusInputRef.current) {
      focusInputRef.current.focus();
    }
  };

  const fetchApiData = async () => {
    const token = localStorage.getItem('token');
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${apiUrl}/api/section/totel/${id}/${subjectId}`,
      headers: {
        Authorization: token,
      },
    };

    try {
      const response = await axios.request(config);
      setMarksData(response.data.quctionTotelmarke);
      setTotalquestions(response.data.totalMarks);
    } catch (err) {
      console.error(err);
      console.log('error');
    } finally {
      console.log('completed');
    }
  };

  useEffect(() => {
    fetchApiData();
  }, []);

  const handleRowChange = (e, index, isOther = false) => {
    const { name, value, checked, type } = e.target;
    if (name === 'marks') {
      setIsAnyQusMarks(value);
    }
    const targetRows = isOther ? [...otherRows] : [...rows];
    targetRows[index][name] = type === 'checkbox' ? checked : value;
    isOther ? setOtherRows(targetRows) : setRows(targetRows);
  };

  const addRow = (isOther = false) => {
    const newRow = {
      no: '',
      question: '',
      orQuestion: '',
      marks: '',
      subjectObjectiveId: '',
      isOtherQuestions: false,
    };

    if (isOther) {
      setOtherRows((prevOtherRows) => {
        const updatedOtherRows = [...prevOtherRows, newRow];
        setTimeout(() => {
          const lastIndex = updatedOtherRows.length - 1;
          const newInput = document.querySelector(`#no-other-${lastIndex}`);
          if (newInput) newInput.focus();
        }, 0);
        return updatedOtherRows;
      });
    } else {
      setRows((prevRows) => {
        const updatedRows = [...prevRows, newRow];

        if (isAnyQus) {
          updatedRows.forEach((row) => (row.marks = isAnyQusMarks));
        }

        setTimeout(() => {
          const lastIndex = updatedRows.length - 1;
          const newInput = document.querySelector(`#no-${lastIndex}`);
          if (newInput) newInput.focus();
        }, 0);
        return updatedRows;
      });
    }
  };

  const deleteRow = (index, isOther = false) => {
    const targetRows = isOther ? [...otherRows] : [...rows];
    targetRows.splice(index, 1);
    isOther ? setOtherRows(targetRows) : setRows(targetRows);
  };

  useEffect(() => {
    if (isAnyQus) {
      setRows((prevRows) =>
        prevRows.map((row) => ({
          ...row,
          marks: isAnyQusMarks,
        }))
      );
    }
  }, [isAnyQus, isAnyQusMarks]);

  const handleNoOfAnyQusChange = (e) => {
    if (e.target.value >= 0) setNoOfAnyQus(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoaded(true);
    const token = localStorage.getItem('token');
    let totalMarks = 0;
    let OrSecTotalMarks = 0;
    const questions = rows.map((row) => {
      const marks = parseInt(row.marks, 10);
      totalMarks += marks;
      return {
        no: row.no,
        text: row.question,
        text2: row.orQuestion,
        marks: marks,
        subjectObjectiveId: +row.subjectObjectiveId || null,
        isOtherQuestions:
          isOtherSection || isAnyQus ? false : row.isOtherQuestions,
      };
    });

    const otherSectionQuestions = isOtherSection
      ? otherRows.map((row) => {
          const marks = parseInt(row.marks, 10);
          OrSecTotalMarks += marks;
          return {
            no: row.no,
            text: row.question,
            text2: row.orQuestion,
            marks: marks,
            subjectObjectiveId: +row.subjectObjectiveId || null,
            isOtherQuestions: row.isOtherQuestions,
            isOtherSectionQuestion: true,
          };
        })
      : [];

    if (isOtherSection && OrSecTotalMarks !== totalMarks) {
      toast.error(
        'Or Section total marks should be equal to main section total marks'
      );
      setLoaded(false);
      return;
    }

    const data = {
      name: examName,
      subjectId: parseInt(subjectId, 10),
      examId: parseInt(id, 10),
      questions: questions,
      otherSectionQuestions: otherSectionQuestions,
      isAnyQus: isAnyQus,
      noOfAnyQus: isAnyQus ? parseInt(noOfAnyQus, 10) : 0,
    };

    axios
      .post(`${apiUrl}/api/section`, data, {
        headers: {
          Authorization: token,
        },
      })
      .then((response) => {
        fetchApiData();
        toast.success('Section added successfully');
        focus();
        setLoaded(false);
        setIsAnyQus(false);
        setIsOtherSection(false);
        resetForm();
        if (selectionType === 'one' && currentPath === '/AddSection') {
          const timeOutDuration = 3000;
          const timeoutId = setTimeout(() => {
            if (window.location.pathname === '/AddSection') {
              navigate(-1);
            }
          }, timeOutDuration);
          return () => clearTimeout(timeoutId);
        }
      })
      .catch((error) => {
        toast.error(error.response?.data?.message);
        error.response?.status === 401 && navigate('/');
        setLoaded(false);
      });
  };

  const resetForm = () => {
    setExamName('');
    setRows([
      {
        no: '',
        question: '',
        orQuestion: '',
        marks: '',
        subjectObjectiveId: '',
        isOtherQuestions: false,
      },
    ]);
    setOtherRows([
      {
        no: '',
        question: '',
        orQuestion: '',
        marks: '',
        subjectObjectiveId: '',
        isOtherQuestions: false,
      },
    ]);
  };

  const handleChange = (e) => {
    setExamName(e.target.value);
  };

  const Normal = () => {
    console.log('called');
    setOrqsn(false);
    setIsOtherSection(false);
    setIsAnyQus(false);
  };

  return (
    <AdminLayout ac4="active">
      <main id="main" className="main">
        <div className="pagetitle mb-4">
          <nav>
            <ol className="breadcrumb">
              <li
                className="breadcrumb-item cursor-pointer"
                onClick={() => navigate(-2)}
              >
                ExamDetails
              </li>
              <li
                className="breadcrumb-item cursor-pointer"
                onClick={() => navigate(-1)}
              >
                List Section
              </li>
              <li className="breadcrumb-item active">Add Section </li>
            </ol>
          </nav>
        </div>
        <section className="section col-lg-12">
          <div className="row">
            <div className="card">
              <div>
                <div className="col-12 mt-3 ">
                  <div className="d-flex align-items-center justify-content-center ">
                    Total marks for all section:{' '}
                    {marksData +
                      (isAnyQus
                        ? noOfAnyQus * parseInt(isAnyQusMarks || 0)
                        : rows.reduce(
                            (acc, row) => acc + parseInt(row.marks || 0),
                            0
                          ))}
                    /{totalquestions}
                  </div>
                </div>
              </div>

              <div className="card-body mt-1">
                <form onSubmit={handleSubmit}>
                  <div className=" ">
                    <div className=" mt-1 mx-3">
                      <div className="container  px-1 ">
                        <div className="row row-cols-12 mb-4 align-items-center">
                          <div className="col-12 d-flex justify-content-center mb-1">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="mainSection"
                                name="sectionType"
                                checked={!isOtherSection && !isAnyQus}
                                onChange={() => Normal()}
                                style={{ width: '25px', height: '25px' }}
                              />
                              <label
                                className="form-check-label mt-1 mx-1"
                                htmlFor="mainSection"
                              >
                                Normal Section
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="otherSection"
                                name="sectionType"
                                checked={isOtherSection}
                                onChange={() => {
                                  setIsOtherSection(true);
                                  setIsAnyQus(false);
                                }}
                                style={{ width: '25px', height: '25px' }}
                              />
                              <label
                                className="form-check-label mt-1 mx-1"
                                htmlFor="otherSection"
                              >
                                OR Section
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                id="anyQuestion"
                                name="sectionType"
                                checked={isAnyQus}
                                onChange={() => {
                                  setIsAnyQus(true);
                                  setIsOtherSection(false);
                                }}
                                style={{ width: '25px', height: '25px' }}
                              />
                              <label
                                className="form-label mt-1 mx-1"
                                htmlFor="anyQuestion"
                              >
                                Any Question
                              </label>
                            </div>
                          </div>
                          <div className="col-2 ">
                            <div className="form-floating">
                              <input
                                className="form-control"
                                type="number"
                                name="totalMarks"
                                disabled
                                readOnly
                                required
                                placeholder="Total Marks"
                                value={
                                  isAnyQus
                                    ? parseInt(noOfAnyQus || 0) *
                                      parseInt(isAnyQusMarks || 0)
                                    : rows.reduce(
                                        (acc, row) =>
                                          acc + parseInt(row.marks || 0),
                                        0
                                      )
                                }
                              />

                              <label className="form-label">
                                Total <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>
                          <div className="col-7 ">
                            <div className="form-floating ">
                              <input
                                className="form-control"
                                type="text"
                                name="examName"
                                value={examName}
                                onChange={handleChange}
                                placeholder="Exam Name"
                                required
                                ref={focusInputRef}
                              />
                              <label className="form-label">
                                Section Name{' '}
                                <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>
                          <div className="col-2">
                            {isAnyQus && (
                              <div className="form-floating px-1">
                                <input
                                  className="form-control"
                                  type="number"
                                  value={noOfAnyQus}
                                  onChange={handleNoOfAnyQusChange}
                                  min={1}
                                  max={rows?.length - 1}
                                  placeholder="No"
                                  onWheel={(e) => e.target.blur()}
                                  required
                                />
                                <label className="form-label">
                                  Any Question{' '}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <hr style={{ width: '104%', marginLeft: '-2%' }} />
                      {rows.map((row, index) => (
                        <div key={index} className="row mb-2 ">
                          <div className="container text-center">
                            <div className="row justify-content-md-center">
                              <div className="container">
                                <div className="row row-cols-5 gap-3">
                                  <div className="col-2">
                                    <div className="form-floating">
                                      <input
                                        className="form-control"
                                        type="text"
                                        name="no"
                                        id={`no-${index}`}
                                        value={row.no}
                                        onChange={(e) =>
                                          handleRowChange(e, index)
                                        }
                                        placeholder="No"
                                        required
                                      />
                                      <label className="form-label">
                                        No<span className="text-danger">*</span>
                                      </label>
                                    </div>
                                  </div>

                                  <div className="col-3">
                                    <div className="form-floating">
                                      <select
                                        className="form-select"
                                        name="subjectObjectiveId"
                                        value={row.subjectObjectiveId}
                                        onChange={(e) =>
                                          handleRowChange(e, index)
                                        }
                                      >
                                        <option value="">
                                          Select Objective
                                        </option>
                                        {objectives.map((obj) => (
                                          <option key={obj.id} value={obj.id}>
                                            {obj.objectiveName}
                                          </option>
                                        ))}
                                      </select>
                                      <label className="form-label">
                                        Objective
                                      </label>
                                    </div>
                                  </div>

                                  <div className="col-1 mt-2">
                                    <div className="d-flex align-items-center justify-content-center">
                                      <input
                                        className="form-check-input mt-0"
                                        type="checkbox"
                                        disabled={true}
                                        checked={true}
                                        style={{
                                          width: '25px',
                                          height: '25px',
                                        }}
                                      />
                                      <label className="form-label ms-2 mt-2">
                                        Q
                                      </label>
                                    </div>
                                  </div>

                                  <div className="col-2 mt-2">
                                    <div className="d-flex align-items-center justify-content-center">
                                      <input
                                        className="form-check-input mt-0"
                                        type="checkbox"
                                        name="isOtherQuestions"
                                        checked={row.isOtherQuestions}
                                        hidden={
                                          orqsn || isAnyQus || isOtherSection
                                        }
                                        onChange={(e) =>
                                          handleRowChange(e, index)
                                        }
                                        style={{
                                          width: '25px',
                                          height: '25px',
                                        }}
                                      />
                                      <label
                                        className="form-label ms-2 mt-2"
                                        hidden={
                                          orqsn || isAnyQus || isOtherSection
                                        }
                                      >
                                        Or Question
                                      </label>
                                    </div>
                                  </div>

                                  <div className="col-2">
                                    <div className="form-floating">
                                      <input
                                        className="form-control"
                                        type="number"
                                        name="marks"
                                        value={row.marks}
                                        onChange={(e) =>
                                          handleRowChange(e, index)
                                        }
                                        placeholder="Marks"
                                        required
                                        disabled={
                                          index > 0
                                            ? isAnyQus && isAnyQusMarks
                                            : false
                                        }
                                        onWheel={(e) => e.target.blur()}
                                      />
                                      <label className="form-label">
                                        Marks
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>
                                  </div>

                                  <div className="col-1">
                                    <div className="col-sm mt-2">
                                      <button
                                        type="button"
                                        className="btn btn-danger"
                                        onClick={() => deleteRow(index)}
                                      >
                                        <i className="bi bi-trash-fill"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                      <hr style={{ width: '104%', marginLeft: '-2%' }} />

                      <div className="row mb-3 ">
                        <div className="col text-end">
                          <button
                            type="button"
                            className="btn btn-primary justify-content-center mx-2"
                            onClick={() => addRow()}
                          >
                            <i className="bi bi-journal-plus"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {isOtherSection && (
                    <div className="">
                      <div className=" mt-4  mx-3">
                        <hr style={{ width: '104%', marginLeft: '-2%' }} />
                        {otherRows.map((row, index) => (
                          <div key={index} className="row mb-2 ">
                            <div className="container text-center">
                              <div className="row justify-content-md-center">
                                <div className="container">
                                  <div className="row row-cols-5 gap-3">
                                    <div className="col-2">
                                      <div className="form-floating">
                                        <input
                                          className="form-control"
                                          type="text"
                                          name="no"
                                          value={row.no}
                                          id={`no-other-${index}`}
                                          onChange={(e) =>
                                            handleRowChange(
                                              e,
                                              index,
                                              isOtherSection
                                            )
                                          }
                                          placeholder="No"
                                          required
                                        />
                                        <label className="form-label">
                                          No
                                          <span className="text-danger">*</span>
                                        </label>
                                      </div>
                                    </div>

                                    <div className="col-3">
                                      <div className="form-floating">
                                        <select
                                          className="form-select"
                                          name="subjectObjectiveId"
                                          value={row.subjectObjectiveId}
                                          onChange={(e) =>
                                            handleRowChange(
                                              e,
                                              index,
                                              isOtherSection
                                            )
                                          }
                                        >
                                          <option value="">
                                            Select Objective
                                          </option>
                                          {objectives.map((obj) => (
                                            <option key={obj.id} value={obj.id}>
                                              {obj.objectiveName}
                                            </option>
                                          ))}
                                        </select>
                                        <label className="form-label">
                                          Objective
                                        </label>
                                      </div>
                                    </div>

                                    <div className="col-1 mt-2">
                                      <div className="d-flex align-items-center justify-content-center">
                                        <input
                                          className="form-check-input mt-0"
                                          type="checkbox"
                                          disabled={true}
                                          checked={true}
                                          style={{
                                            width: '25px',
                                            height: '25px',
                                          }}
                                        />
                                        <label className="form-label ms-2 mt-2">
                                          Q
                                        </label>
                                      </div>
                                    </div>

                                    <div className="col-2 mt-2">
                                      <div className="d-flex align-items-center justify-content-center">
                                        <input
                                          className="form-check-input mt-0"
                                          type="checkbox"
                                          name="isOtherQuestions"
                                          checked={row.isOtherQuestions}
                                          hidden={isAnyQus || isOtherSection}
                                          onChange={(e) =>
                                            handleRowChange(
                                              e,
                                              index,
                                              isOtherSection
                                            )
                                          }
                                          style={{
                                            width: '25px',
                                            height: '25px',
                                          }}
                                        />
                                        <label
                                          className="form-label ms-2 mt-2"
                                          hidden={isAnyQus || isOtherSection}
                                        >
                                          Or Q
                                        </label>
                                      </div>
                                    </div>

                                    <div className="col-2">
                                      <div className="form-floating">
                                        <input
                                          className="form-control"
                                          type="number"
                                          name="marks"
                                          value={row.marks}
                                          onChange={(e) =>
                                            handleRowChange(
                                              e,
                                              index,
                                              isOtherSection
                                            )
                                          }
                                          placeholder="Marks"
                                          required
                                          onWheel={(e) => e.target.blur()}
                                        />
                                        <label className="form-label">
                                          Marks
                                          <span className="text-danger">*</span>
                                        </label>
                                      </div>
                                    </div>

                                    <div className="col-1">
                                      <div className="col-sm mt-2">
                                        <button
                                          type="button"
                                          className="btn btn-danger"
                                          onClick={() =>
                                            deleteRow(index, isOtherSection)
                                          }
                                        >
                                          <i className="bi bi-trash-fill"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                        <hr style={{ width: '104%', marginLeft: '-2%' }} />
                        <div className="row mb-3 ">
                          <div className="col text-end">
                            <button
                              type="button"
                              className="btn btn-primary justify-content-center mx-2"
                              onClick={() => addRow(isOtherSection)}
                            >
                              <i className="bi bi-journal-plus"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="row ">
                    <div className="d-flex justify-content-between ">
                      <div className="p-2 mx-1 bd-highlight">
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input recode-switch"
                            type="checkbox"
                            id="selectionSwitch"
                            checked={selectionType === 'many'}
                            onChange={() =>
                              setSelectionType(
                                selectionType === 'many' ? 'one' : 'many'
                              )
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="selectionSwitch"
                          >
                            {selectionType === 'many'
                              ? 'Many Section Add'
                              : 'One Section Add'}
                          </label>
                        </div>
                      </div>

                      <div className="p-2 mx-1 bd-highlight">
                        <button
                          type="button"
                          className="btn btn-primary px-3"
                          onClick={() => navigate(-1)}
                        >
                          <i className="bi bi-arrow-bar-left"></i>Back
                        </button>

                        <button
                          type="submit"
                          className="btn btn-primary  px-4 mx-2"
                          disabled={loaded}
                        >
                          {loaded ? (
                            <>
                              {' '}
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>{' '}
                              wait...
                            </>
                          ) : (
                            <>Save</>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                <ToastContainer
                  position="top-center"
                  style={{ width: 'auto' }}
                />
              </div>
            </div>
          </div>
        </section>
      </main>
    </AdminLayout>
  );
}
